import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';


import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/filter';

import { ConfigService } from '../config/config.service';
import { Product } from '../products/product';
import { ProductsService } from '../products/products.service';
import { ProductImage } from '../products/product-image';
import { ProductImageService } from '../products/product-image.service';
import { CartService } from '../cart/cart.service';
import { LoggingService } from '../loging/logging.service';
export class ProductImageListComponent implements OnInit {

    products: Product[];
private oddProducts: Product[];
private evenProducts: Product[];
private productIndexes: number[] = [];
    selectedProduct: Product;
private productImages: ProductImage[];
private config: any;
    // @Input() productImageListConfig: ProductImageListConfig = new ProductImageListConfig();
     cartService: CartService;
/**
 * @param {?} router
 * @param {?} configService
 * @param {?} productsService
 * @param {?} productImageService
 * @param {?} loggingService
 */
constructor(
private router: Router,
private configService: ConfigService,
private productsService: ProductsService,
private productImageService: ProductImageService,
private loggingService: LoggingService
    ) {
        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
        });
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.loggingService.log('ProductImageListComponent:ngOnInit()');
        this.getProducts();
    }
/**
 * @return {?}
 */
getProducts(): void {
        this.productsService.getProducts().subscribe(
            products => {
                this.loggingService.log('product-image-list.components.ts: products = ');
                this.loggingService.log(products);

                this.products = products;
                this.getMainImages();

                let /** @type {?} */ count = 0;
                this.productIndexes = [];

                this.oddProducts = this.products.filter(
                    (value, index) => {
                        // this.loggingService.log('home.component.getProducts().oddProducts:value = ' + JSON.stringify(value));
                        if (!(index % 2)) {
                            this.productIndexes.push(count);
                            count++;
                            return true;
                        }
                    }
                );

                this.evenProducts = this.products.filter(
                    (value, index) => {
                        // this.loggingService.log('home.component.getProducts().evenProducts:value = ' + JSON.stringify(value));
                        return index % 2;
                    }
                );

            });
    }
/**
 * @return {?}
 */
getMainImages(): void {
        for (let /** @type {?} */ i = 0; i < this.products.length; i++) {

            let /** @type {?} */ product: Product = this.products[i];

            if (product != null) {
                this.productImageService.getMainProductImage(product.id).subscribe(
                    (mainProductImage) => {
                        // this.loggingService.log('home.component.getMainImages.foundMainImage = ' + JSON.stringify(mainProductImage));

                        if (mainProductImage != null) {
                            product.mainImageUrl = this.config.awsBucket + mainProductImage.Key;
                        }
                    },
                    (err) => {
                        this.loggingService.log('home.component.getMainImages.err = ' + err);
                    }
                );
            } else {
                this.loggingService.log("product-image-list.component.ts:getMainImages() error - invalid product");
            }


        }
    }
/**
 * @param {?} product
 * @return {?}
 */
onSelect(product: Product): void {
        this.selectedProduct = product;
    }
/**
 * @param {?} product
 * @return {?}
 */
deleteProducts(product: Product): void {
        this.productsService.deleteProduct(product.id).subscribe(
            () => {
                this.products = this.products.filter(p => p !== product);
                if (this.selectedProduct === product) {
                    this.selectedProduct = null;
                }
            });
    }
/**
 * @param {?} id
 * @return {?}
 */
gotoDetail(id: string): void {
        this.router.navigate(['/product-details', id]);
    }
/**
 * @param {?} productId
 * @return {?}
 */
buyNow(productId: string): void {
        let /** @type {?} */ product = this.products.find((foundProduct) => {
            return foundProduct.id === productId;
        });

        this.cartService.add(product);
        this.router.navigate(['/checkout']);
    }
/**
 * @param {?} product
 * @return {?}
 */
addToCart(product: Product): void {
        //this.loggingService.log('product-image-list.component.addToCart product = ' + JSON.stringify(product));
        //this.loggingService.log('this.cartService = ' + JSON.stringify(this.cartService));
        //this.loggingService.log('this.cartService.add = ' + this.cartService.add);
        this.cartService.add(product);
        //this.loggingService.log('this.cartService = ' + JSON.stringify(this.cartService));
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-product-image-list',
    template: "<div class=\"product-image-list\"> <div *ngFor=\"let productIndex of productIndexes\" class=\"row\"> <div class=\"col-xs-6 product-image-div\"> <img id=\"mainImage\" (click)=\"gotoDetail(oddProducts[productIndex].id)\" src=\"{{oddProducts[productIndex].mainImageUrl}}\" class=\"img-responsive center-block product-image\" alt=\"{{oddProducts[productIndex].name}}\" align=\"middle\" /><br/> <span class=\"product-name\" (click)=\"gotoDetail(oddProducts[productIndex].id)\">{{oddProducts[productIndex].name}}<br/>${{oddProducts[productIndex].price}}</span><br/> <!-- <button class=\"buy-now-button\" (click)=\"buyNow(oddProducts[productIndex].id)\">Buy<br/>Now!</button><button class=\"add-to-cart-button\" (click)=\"addToCart(oddProducts[productIndex])\">Add to Cart</button> --> </div> <div *ngIf=\"evenProducts[productIndex]\" class=\"col-xs-6 product-image-div\"> <img id=\"mainImage\" (click)=\"gotoDetail(evenProducts[productIndex].id)\" src=\"{{evenProducts[productIndex].mainImageUrl}}\" class=\"img-responsive center-block product-image\" alt=\"{{evenProducts[productIndex].name}}\" align=\"middle\" /><br/> <span class=\"product-name\" (click)=\"gotoDetail(evenProducts[productIndex].id)\">{{evenProducts[productIndex].name}}<br/>${{evenProducts[productIndex].price}}</span><br/> <!-- <button *ngIf=\"productImageListConfig.includeBuyNowButton\" class=\"buy-now-button\" (click)=\"buyNow(evenProducts[productIndex].id)\">Buy<br/>Now!</button><button  *ngIf=\"productImageListConfig.includeAddToCartButton\" class=\"add-to-cart-button\" (click)=\"addToCart(evenProducts[productIndex])\">Add to Cart</button> --> </div> </div> </div>",
    styles: ["// component styles are encapsulated and only applied to their components .home-text { color: #ff0000; } .buy-now-button { font-size: 0.8em; font-style: italic; background-color: bisque; color: black; font-weight: bold; width:50%; } .add-to-cart-button { font-size: 0.8em; font-style: italic; background-color: aquamarine; color: black; font-weight: bold; width:50%; } .product-name{ font-size: 1em; font-weight: bold; width: 100%; } .product-image-div{ align-content: center; margin-bottom: 1em; } .product-image-list{ overflow: auto; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: ConfigService, },
{type: ProductsService, },
{type: ProductImageService, },
{type: LoggingService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cartService': [{ type: Input },],
};
}

function ProductImageListComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductImageListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductImageListComponent.ctorParameters;
/** @type {?} */
ProductImageListComponent.propDecorators;
/** @type {?} */
ProductImageListComponent.prototype.products;
/** @type {?} */
ProductImageListComponent.prototype.oddProducts;
/** @type {?} */
ProductImageListComponent.prototype.evenProducts;
/** @type {?} */
ProductImageListComponent.prototype.productIndexes;
/** @type {?} */
ProductImageListComponent.prototype.selectedProduct;
/** @type {?} */
ProductImageListComponent.prototype.productImages;
/** @type {?} */
ProductImageListComponent.prototype.config;
/** @type {?} */
ProductImageListComponent.prototype.cartService;
/** @type {?} */
ProductImageListComponent.prototype.router;
/** @type {?} */
ProductImageListComponent.prototype.configService;
/** @type {?} */
ProductImageListComponent.prototype.productsService;
/** @type {?} */
ProductImageListComponent.prototype.productImageService;
/** @type {?} */
ProductImageListComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
